import { useTranslation } from 'react-i18next';
import { PROJECT } from '@immoaktas/shared';
import { Icon } from '../ui';
import { siteUrl } from '../lib/purchase';

/** Legal pages on the website (§ 5 DDG: Impressum reachable from every page, also behind the login). */
export const LEGAL_PAGES = [
  { key: 'imprint', path: '/impressum' },
  { key: 'privacy', path: '/datenschutz' },
  { key: 'terms', path: '/agb' },
  { key: 'withdrawal', path: '/widerruf' },
] as const;

export const legalUrl = (path: string) => siteUrl(`${PROJECT.urls.landing}${path}`);

/** § 312k BGB Kündigungsbutton: the public cancellation page of this app (routes/auth/Cancel.tsx), no login needed. */
export const CANCEL_PATH = '/kuendigen';

/** Entries for the landlord account menu. */
export function LegalMenuLinks() {
  const { t } = useTranslation();
  return (
    <>
      {LEGAL_PAGES.map((p) => (
        <a key={p.key} href={legalUrl(p.path)} target="_blank" rel="noreferrer"><Icon name="external" />{t(`app.legal.${p.key}`)}</a>
      ))}
      <a href={CANCEL_PATH}><Icon name="external" />{t('app.legal.cancel')}</a>
    </>
  );
}

/** Small footer line (tenant portal). */
export function LegalFooter() {
  const { t } = useTranslation();
  return (
    <nav className="small muted legal-footer" aria-label={t('app.legal.label')} style={{ display: 'flex', flexWrap: 'wrap', gap: 16, justifyContent: 'center', padding: '8px 0 24px' }}>
      {LEGAL_PAGES.map((p) => (
        <a key={p.key} href={legalUrl(p.path)} target="_blank" rel="noreferrer">{t(`app.legal.${p.key}`)}</a>
      ))}
    </nav>
  );
}
